import { BaseValidator } from '@shared/validators/base-validator';
import { BaseValidationError } from '@shared/validators/validation-error/base-error';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { TranslationService } from '@core/translation/translation.service';

export class U2BDateRequiredValidator extends BaseValidator {

    public validationError: BaseValidationError;

    constructor(private message?: string) {
        super();
        this.validationError = new BaseValidationError(
            'required',
            message ?? TranslationService.translate('common.validation.dateFormat')
        );
    }

    public validate(control: AbstractControl): ValidationErrors | null {

        if (!control.value) {
            if (control.errors && control.errors['matDatepickerParse'] && control.errors['matDatepickerParse'].text !== '') {
                return this.IS_VALID;
            }
            return this.IS_INVALID;
        }

        return this.IS_VALID;
    }
}
